import { Settings } from '../types';

export const defaultSettings: Settings = {
  openaiUrl: 'https://openrouter.ai/api/v1',
  openaiKey: '',
  imageRouterKey: '',
  imageToTextModel: 'meta-llama/llama-4-maverick:free',
  textToImageModel: 'black-forest-labs/FLUX-1-schnell:free',
  textModel: 'meta-llama/llama-4-maverick:free',
  systemPrompt: 'Your job is to take whatever descriptive text that is given to you and generate an image.'
}; 